import { isNullOrUndefined } from '../../../util/is-null-or-undefined.util';

/**
 * Modelo de solicitação de op do serviço do Router
 * @export
 * @class RequisicaoOp
 */
export class RequisicaoOp {
  body: Array<any>;
  method: 'GET' | 'POST' | 'DELETE' | 'PATCH' | 'PUT';
  header: Array<any>;
  query: Array<any>;
  path: Array<any>;
  op: string;

  constructor() {
    this.header = [];
    this.query = [];
    this.path = [];
    this.body = null;
    this.method = null;
    this.op = null;
  }

  /**
   * Método genérico responsável por adicionar parâmetros em um array de objeto RequisicaoParametroCharon
   */
  private adicionaParametrosRequisicao(
    proriedade: Array<any>,
    parametro: any
  ): Array<any> {
    if (isNullOrUndefined(proriedade)) {
      proriedade = [];
    }

    if (!isNullOrUndefined(parametro)) {
      proriedade.push(parametro);
      return proriedade;
    }
  }

  /**
   * Método responsável por adicionar um novo parâmetro do tipo header
   */
  adicionaCabecalhoObjetoCorpoRequisicao(parametro: any) {
    if (isNullOrUndefined(this.header)) {
      this.header = [];
    }

    if (!isNullOrUndefined(parametro)) {
      this.header.push(parametro);
    }
  }

  /**
   * Método responsável por adicionar um novo parâmetro do tipo query
   */
  adicionaParametrosQueryRequisicao(parametro: any) {
    if (isNullOrUndefined(this.query)) {
      this.query = [];
    }

    if (!isNullOrUndefined(parametro)) {
      this.query.push(parametro);
    }
  }

  /**
   * Método responsável por adicionar um novo parâmetro do tipo path
   */
  adicionaParametrosPathRequisicao(parametro: any) {
    if (isNullOrUndefined(this.path)) {
      this.path = [];
    }

    if (!isNullOrUndefined(parametro)) {
      this.path.push(parametro);
    }
  }

  /**
   * Método responsável por atribuir um parâmetro do tipo body
   * @param parametro deve ser um array representando o body
   */
  adicionaBodyRequisicao(parametro: any) {
    this.body = parametro;
  }
}
